import { IconButton } from '@mui/material';
import { CSSProperties } from 'react';
import { FaEnvelope } from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import MenuToggle from '~/shared/layouts/MenuToggle';
import { getLcn } from '~/utils/labeled-classnames';
import { useIsAtOrNarrowerThan } from '~/shared/utils/useBreakpoint';
import { publicStorageUrl } from '~/utils/paths';
import { UserMenu } from '~/shared/layouts/UserMenu';
export const logoUrl = publicStorageUrl('landlogic/images/logos/webp/logo_simple_sm.webp');

const ContactButton = () => {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={() => { navigate('/pages/contact') }}>
      <FaEnvelope />
    </IconButton>
  )
}

const Banner = () => {
  const isXs = useIsAtOrNarrowerThan('xs');
  const navigate = useNavigate();

  const styles: { [key: string]: CSSProperties } = {
    bannerComponent: {
    },
    signOut: {
      position: 'relative',
      zIndex: '11',
    },
    brandText: {
      position: 'relative',
      zIndex: '10',
    },
  }

  const lcn = getLcn({
    bannerComponent: [
      'flex flex-col bg-white',
      'relative ',
      'mb-4 sm:mb-2 '
    ],
    wideLine: [
      'flex items-center justify-center sm:justify-between sm:p-2 bg-scene',
      'relative '
    ],
    branding: [
      'flex gap-1 items-center w-full justify-center',
    ],
    logoBar: [
      'flex gap-1 sm:gap-4 brand-font text-3xl transition-all  sm:text-5xl ',
      'items-end',
    ],
    logo: 'h-auto w-[80px] sm:w-[100px] transition-all ',
    company: 'text-primary ',
    for: 'brand-font text-lg sm:text-2xl text-[#c78b2d] sm:text-center',
  });

  const { sessionUser } = useCommonAppContext()

  return (
    <div id='banner-component' className={lcn.bannerComponent} style={styles.bannerComponent}>

      <div className={lcn.wideLine} >
        <div>
          <MenuToggle />
        </div>

        <Link to="/" className={lcn.logoBar} style={styles.brandText}>
          <div className={lcn.branding}>
            <div>
              <div className={lcn.company}> Ben's Song Charts</div>
            </div>
          </div>
        </Link>
        <div>
          <UserMenu />
        </div>
      </div>
    </div >

  )
}

export default Banner;